module.exports = __webpack_public_path__ + "static/media/banner.1d9a978e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/banner.jpg
// module id = 339
// module chunks = 1